module.exports = __webpack_public_path__ + "img/logo.a97c514b.png";